import React, { useState } from "react";
import "./IpSummary.scss";
import { formatDate } from "../../../../services/helpFunctions/formatDateAndTime";

// Utility function to get IP Status description
const getIpStatusDescription = (enumValue) => {
  const descriptions = {
    1: "Assigned",
    2: "In progress",
    3: "On hold",
    4: "Resolved",
    5: "Archived",
  };
  return descriptions[enumValue] || "Unknown";
};

function RedFlagCards({ projectData }) {
  const [selected, setSelected] = useState(null);

  const cardsData = Array.isArray(
    projectData?.data?.ipSummaryRedFlagCardsResponse
  )
    ? projectData.data.ipSummaryRedFlagCardsResponse
    : [];

  const selectedCardKeyInfo = selected
    ? cardsData.find((card) => card.redFlagIdentifier === selected)
        ?.redFlagKeyInfo
    : null;

  // Was the one deck built out of bootstrap .card / .col-12 .col-lg-3 while the
  // other two used .cardIp, so the three decks on this page looked like three
  // different components. They share the deck markup now.
  return (
    <div className="ipCardDiv">
      <h2 className="ipCardName">Red Flag Cards</h2>
      <div className="ipCardsLayout">
        <div className="ipCards">
          {cardsData.length === 0 && (
            <span className="ipCardsEmpty">No red flag cards.</span>
          )}
          {cardsData.map((card) => (
            <div
              key={card.redFlagIdentifier}
              className={`cardIp${
                selected === card.redFlagIdentifier ? " cardIp--selected" : ""
              }`}
              role="button"
              tabIndex={0}
              onClick={() => setSelected(card.redFlagIdentifier)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ")
                  setSelected(card.redFlagIdentifier);
              }}
            >
              <h6 className="ipCardHeadingName">{card?.redFlagIdentifier}</h6>
              <span className="ipCardTextName">
                IP Name: <span>{card?.ipName}</span>
              </span>
              <span className="ipCardTextName">
                Date of Visit: <span>{formatDate(card?.dateOfVisit)}</span>
              </span>
              <span className="ipCardTextName">
                Site Visit ID: <span>{card?.siteVisitIdentifier}</span>
              </span>
              <span className="ipCardTextName">
                Assigned To: <span>{card?.assignedTo}</span>
              </span>
            </div>
          ))}
        </div>
        <div className="ipCardList">
          <h3 className="ipCardListTitle">Key info</h3>
          {selectedCardKeyInfo ? (
            <>
              <span className="ipCardTextName">
                Due Date:{" "}
                <span>{formatDate(selectedCardKeyInfo.dueDate)}</span>
              </span>
              <span className="ipCardTextName">
                Follow Up Notes:{" "}
                <span>{selectedCardKeyInfo.followUpNotes}</span>
              </span>
              <span className="ipCardTextName">
                Last Update:{" "}
                <span>{formatDate(selectedCardKeyInfo.lastUpdate)}</span>
              </span>
              <span className="ipCardTextName">
                Red Flag Status:{" "}
                <span>
                  {getIpStatusDescription(selectedCardKeyInfo.redFlagStatus)}
                </span>
              </span>
            </>
          ) : (
            <span className="ipCardTextName">
              Select a card to see its key info
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default RedFlagCards;
